<template>
  <div>
    <empty-state
      v-if="loading || !data || data.length === 0"
      :loading="loading"
      :title="loading ? $t('loading') : $t('no_data_available')"
      :subtitle="!loading ? $t('no_companies_found') : ''"
      icon="mdi-truck-delivery"
    />

    <div v-else class="pa-1">
      <!-- Mobile View -->
      <div v-if="device.isMobile">
        <v-card
          v-for="(item, index) in customSearch(data, mobileHeaders, searchQuery)"
          :key="index"
          class="mb-3 ordera-box-shadow"
        >
          <v-card-title class="py-2">
            <v-icon left color="primary">mdi-domain</v-icon>
            <span class="font-weight-bold">{{ item.company }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-2">
            <v-row dense>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <v-icon small class="mr-2 grey--text">mdi-map-marker</v-icon>
                  <span class="text-body-2">{{ item.address }}</span>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex align-center">
                  <v-icon small class="mr-2 grey--text">mdi-phone</v-icon>
                  <span class="text-body-2">{{ item.phone }}</span>
                </div>
              </v-col>
              <v-col cols="6" class="text-right">
                <v-chip small color="primary" outlined>
                  {{ item.orders }} {{ $t("orders") }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>

      <!-- Desktop View -->
      <v-data-table
        v-else
        :headers="headers"
        :items="customSearch(data, headers, searchQuery)"
        class="striped-table ordera-box-shadow"
        :loading="loading"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.num="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.orders="{ item }">
          <v-chip small color="primary" outlined>
            {{ item.orders }}
          </v-chip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  name: "CompaniesDeliveryTable",
  components: {
    EmptyState,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("company"), value: "company", sortable: false },
        { text: this.$t("address"), value: "address", sortable: false },
        { text: this.$t("phone_no"), value: "phone", sortable: false },
        { text: this.$t("delivered_orders"), value: "orders", sortable: false, align: "center" },
      ];
    },
    mobileHeaders() {
      return [
        { text: this.$t("company"), value: "company", sortable: false },
        { text: this.$t("address"), value: "address", sortable: false },
        { text: this.$t("phone_no"), value: "phone", sortable: false },
        { text: this.$t("delivered_orders"), value: "orders", sortable: false },
      ];
    },
  },
};
</script>
